import vmClient from 'app/services/vmClient';
import { Entity, EntityStringId, IEntity, IEntityType } from 'app/types/entity';
import { IText, Text } from 'app/constants/schemas/Text';
import { ALL_TRANSLATIONS } from 'app/constants/schemas/translations';
import pick from 'lodash/pick';
import { BrandTranslations } from 'app/constants/schemas/Brand';

export interface IBrandReference extends IEntity {
  attributes: {
    id: EntityStringId;
  };
  associations: {
    name: IText;
  };
}

export type BrandReference = Entity<IBrandReference>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrandReference: IEntityType<IBrandReference> = vmClient.defineClass({
  typeName: 'BrandReference',
  version: 1,
  persisted: true,
  associations: {
    name: {
      type: Text,
      notNull: true,
    },
  },
});

export const BrandReferenceTranslations = pick(BrandTranslations, ['id', 'name']);
ALL_TRANSLATIONS.set(BrandReference, BrandReferenceTranslations);
